import type { ReactNode } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Small uppercase tracked label shown above the title — e.g. a module/section name. Optional,
   * matches the design template's "eyebrow" convention without forcing every caller to supply one. */
  eyebrow?: string;
  actions?: ReactNode;
}

export default function PageHeader({ title, subtitle, eyebrow, actions }: PageHeaderProps) {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', md: 'center' }}
      spacing={2}
      sx={{ mb: 3 }}
    >
      <Stack spacing={0.5}>
        {eyebrow ? (
          <Typography
            variant="caption"
            color="primary.main"
            sx={{ textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 700 }}
          >
            {eyebrow}
          </Typography>
        ) : undefined}
        <Typography variant="h2" component="h1">
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body1" color="text.secondary">
            {subtitle}
          </Typography>
        ) : undefined}
      </Stack>
      {actions ? <Stack direction="row" spacing={1.5} flexShrink={0}>{actions}</Stack> : undefined}
    </Stack>
  );
}
